import { render, staticRenderFns } from "./testcomponent.vue?vue&type=template&id=678d7c70&"
import script from "./testcomponent.vue?vue&type=script&lang=js&"
export * from "./testcomponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports